module.exports = __webpack_public_path__ + "static/img/Kiitoskortti_Avecor_camilla-nyman_A4.95057ef.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/salesperson-leaflets/Kiitoskortti_Avecor_camilla-nyman_A4.pdf
// module id = pvKW
// module chunks = 22